

export function inView(elm) {
        const screenHeight = document.documentElement.clientHeight;
        const sectionHeight = elm.current.getBoundingClientRect().height;
        const sectionY = elm.current.getBoundingClientRect().y;

        return screenHeight > sectionY && sectionY + sectionHeight > 0;
}